var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 34c8.837 0 16-7.163 16-16S26.837 2 18 2 2 9.163 2 18s7.163 16 16 16zm0 2c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.951 28h2.136V12.039l6.155 6.155 1.476-1.495L18.02 8l-8.718 8.699 1.514 1.495 6.136-6.155V28z",
    fill: "#111"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzYgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTggMzRDMjYuODM2NiAzNCAzNCAyNi44MzY2IDM0IDE4QzM0IDkuMTYzNDQgMjYuODM2NiAyIDE4IDJDOS4xNjM0NCAyIDIgOS4xNjM0NCAyIDE4QzIgMjYuODM2NiA5LjE2MzQ0IDM0IDE4IDM0Wk0xOCAzNkMyNy45NDExIDM2IDM2IDI3Ljk0MTEgMzYgMThDMzYgOC4wNTg4NyAyNy45NDExIDAgMTggMEM4LjA1ODg3IDAgMCA4LjA1ODg3IDAgMThDMCAyNy45NDExIDguMDU4ODcgMzYgMTggMzZaIiBmaWxsPSJub25lIi8+CjxwYXRoIGQ9Ik0xNi45NTEzIDI4SDE5LjA4NzJWMTIuMDM4OEwyNS4yNDI1IDE4LjE5NDJMMjYuNzE4MyAxNi42OTlMMTguMDE5MiA4TDkuMzAwNzggMTYuNjk5TDEwLjgxNTMgMTguMTk0MkwxNi45NTEzIDEyLjAzODhWMjhaIiBmaWxsPSIjMTExMTExIi8+Cjwvc3ZnPgo=";
export { SvgArrow as ReactComponent };